
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const EmailTemplateForm = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Email Template Form</CardTitle>
      </CardHeader>
      <CardContent>
        <p>Email template form coming soon...</p>
      </CardContent>
    </Card>
  );
};

export default EmailTemplateForm;
